"use client";

import { useCallback } from "react";
import { ROUTER_PATH } from "@config/router";
import { useShellRouter } from "@hooks/useShellAwareRouter";
import { trackEvent } from "@utils/tracking";

export function useFitnessScoreCardNavigation(options?: {
  total?: number;
  delta?: number;
}): { onSeeFullScore: () => void } {
  const router = useShellRouter();

  const onSeeFullScore = useCallback(() => {
    trackEvent("ff_score_result_cta", {
      total: options?.total,
      delta: options?.delta,
    });
    router.push(ROUTER_PATH.MY_SCORE);
  }, [options?.delta, options?.total, router]);

  return { onSeeFullScore };
}
